import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { call, all, takeLatest, put, select, takeEvery } from 'redux-saga/effects';
import get from 'lodash/get';
import { editDeviation, deleteDeviation, deleteDeviationSuccess, fetchDeviation } from './actionCreators';
import { actions as modalActions } from '../../Modals';
import { ModalType } from '../../Modals/redux/types';
import { getDeviationType, getDeviationUrl } from '../../DeviationViews/_helpers';
import { DeviationTypes, DeviationResourceType } from '../../types/deviation';
import { normalize } from '../normalizr';
import { deviationExtendedSchema, deviationSchema, getCompositeId } from '../normalizr/schemas/deviation';
import { putEntities } from '../entities/actions';
import { isApiError, requestPuppy } from '@wix/da-http-client';
import { getIsLoggedIn } from '../../publicSession/selectors';
import { restrictLoggedOut } from '../../redux/loggedout';
import ddt from '@wix/da-ddt';
import { getDeviationById, getDeviationEditUrl, getIsCurrentUserAuthorOf, getNormalizedDeviationById } from './selectors';
import { Url, URLS } from '@wix/da-url';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { publishCommentSuccess } from '../../CommentEditor/redux/actionCreators';
import { publishCommentSuccess as publishCommentSuccessNew } from '../../CommentEditor.editor_v3/redux/actionCreators';
import { getDeviationTypeForCommentableType } from '../../DeviationPage/redux/helpers';
import { getDataEntityById } from '../entities/selectors';
import { awardBadgeSuccess } from '../../coreBadge/redux/actionCreators';
const logger = ddt.createLogger('deviationsaga');
function fakeResponse(options) {
    logger.log('faking the response!');
    if (process.env.NODE_ENV !== 'production') {
        if (typeof window !== 'undefined' && window.doError) {
            return {
                error: 'invalid_request',
                error_description: 'Not logged in.',
                status: 'error'
            };
        }
        if (options && options.url === '/deviation/fetch') {
            // eslint-disable-next-line
            const { deviationsByType } = require('@wix/da-sample-data');
            return _object_spread({}, deviationsByType.image[0], {
                deviationId: options.params.deviationid
            });
        }
        return {
            success: true
        };
    }
}
function* doPostPapiRequest(endpoint, data) {
    logger.log(`calling ${endpoint} endpoint`);
    return yield call(requestPuppy, {
        method: 'post',
        url: endpoint,
        data
    }, fakeResponse);
}
function* doGetPapiRequest(endpoint, params) {
    logger.log(`calling ${endpoint} endpoint`);
    return yield call(requestPuppy, {
        method: 'get',
        url: endpoint,
        params
    }, fakeResponse);
}
function* deleteDeviationSaga({ payload: { deviation, shouldRedirect, redirectTo } }) {
    var _deviation_extended;
    if (!deviation) {
        logger.error('Tried to delete an invalid deviation', deviation);
        return;
    }
    const isLoggedIn = yield select(getIsLoggedIn);
    if (!isLoggedIn) {
        yield put(restrictLoggedOut({
            restrictedActionName: ReferralType.DELETE_DEVIATION
        }));
        return;
    }
    const isOwner = yield select(getIsCurrentUserAuthorOf, deviation);
    var _deviation_extended_canUserDelete;
    const canDelete = (_deviation_extended_canUserDelete = (_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : _deviation_extended.canUserDelete) !== null && _deviation_extended_canUserDelete !== void 0 ? _deviation_extended_canUserDelete : isOwner;
    if (!canDelete) {
        logger.log('Cannot delete deviation', deviation, isOwner);
        return;
    }
    let endpoint, params;
    const deviationType = getDeviationType(deviation);
    const deviationId = deviation.deviationId;
    const userid = deviation.author && deviation.author.userId;
    switch(deviationType){
        case DeviationTypes.STATUS:
            endpoint = '/status/delete';
            params = {
                statusid: deviationId,
                userid
            };
            break;
        case DeviationTypes.POLL:
            endpoint = '/poll/delete';
            params = {
                pollid: deviationId,
                userid
            };
            break;
        case DeviationTypes.COMMISSION:
            endpoint = '/commission/delete';
            params = {
                commissionid: deviationId
            };
            break;
        case DeviationTypes.TIER:
            endpoint = '/tier/delete';
            params = {
                tierid: deviationId
            };
            break;
        default:
            endpoint = '/deviation/delete';
            params = {
                deviationid: deviationId
            };
    }
    const result = yield call(doPostPapiRequest, endpoint, params);
    if (result && !isApiError(result)) {
        if (shouldRedirect || redirectTo) {
            typeof window !== 'undefined' && window.location.assign(redirectTo !== null && redirectTo !== void 0 ? redirectTo : deviation.author ? Url.userLink(deviation.author.username) : URLS.ROOT);
            return;
        }
        const deletedDeviation = _object_spread_props(_object_spread({}, deviation), {
            isDeleted: true
        });
        const { entities } = normalize(deletedDeviation, deviationSchema);
        yield all([
            put(putEntities({
                entities
            })),
            put(deleteDeviationSuccess({
                deviation: deletedDeviation
            }))
        ]);
    }
}
function* getExtendedDeviation(deviation, forceFetch = false) {
    const isExpanded = !!get(deviation, 'textContent.html.markup');
    if (!forceFetch && isExpanded) {
        logger.log('Deviation already expanded', deviation);
        return {
            deviation
        };
    }
    const deviationType = getDeviationType(deviation);
    let result;
    switch(deviationType){
        case DeviationTypes.STATUS:
        case DeviationTypes.LITERATURE:
        case DeviationTypes.JOURNAL:
        case DeviationTypes.COMMISSION:
        case DeviationTypes.POLL:
            const deviationIdPropName = [
                DeviationTypes.JOURNAL
            ].includes(deviationType) ? 'deviationid' : `${deviationType}id`;
            logger.log('Deviation PropName', deviationIdPropName, deviation);
            result = yield call(requestPuppy, {
                method: 'get',
                url: `/${deviationType}`,
                params: {
                    [deviationIdPropName]: deviation.deviationId,
                    username: deviation.author.username,
                    expand: 'deviation.fulltext'
                }
            });
            break;
        case DeviationTypes.TIER:
            result = yield call(requestPuppy, {
                method: 'get',
                url: `/${deviationType}`,
                params: {
                    deviationid: deviation.deviationId,
                    username: deviation.author.username
                }
            });
            break;
        default:
            return deviation;
    }
    // TODO error handling
    if (!result || isApiError(result)) {
        return;
    }
    logger.log('Extended deviation', result.deviation);
    const { entities } = normalize(result.deviation, deviationSchema);
    yield put(putEntities({
        entities
    }));
    return result;
}
/**
 * Listen to editDeviation actions and fire the
 * correct edit deviation action depending on the deviation type.
 */ function* editDeviationSaga({ payload: { deviation } }) {
    const isLoggedIn = yield select(getIsLoggedIn);
    if (!isLoggedIn) {
        yield put(restrictLoggedOut({
            restrictedActionName: ReferralType.EDIT_DEVIATION
        }));
        return;
    }
    // TODO: this allows group members to edit deviations where they have permission,
    // but it requires the full deviation object, otherwise just falls back to author equality
    // this works for now but when we implement group profiles will need to tweak it
    const isOwner = yield select(getIsCurrentUserAuthorOf, deviation);
    const canUserEdit = get(deviation, 'extended.canUserEdit', isOwner);
    if (!canUserEdit) {
        logger.log('Attempted to edit a deviation that is not owned by you.', deviation);
        return;
    }
    const editUrl = getDeviationEditUrl(deviation);
    if (editUrl) {
        return typeof window !== 'undefined' && window.location.assign(editUrl);
    }
    const { isTextEditable, legacyTextEditUrl, extended } = deviation;
    const deviationType = getDeviationType(deviation);
    const needInTiersInfo = [
        DeviationTypes.TIER,
        DeviationTypes.JOURNAL,
        DeviationTypes.STATUS
    ].includes(deviationType);
    const needExtendedInfo = isTextEditable || needInTiersInfo;
    if (needExtendedInfo) {
        const expandedDeviationResult = yield call(getExtendedDeviation, deviation, !extended || needInTiersInfo);
        const params = {
            deviation: expandedDeviationResult.deviation
        };
        switch(deviationType){
            case DeviationTypes.STATUS:
                params.inTiers = expandedDeviationResult.inTiers;
                yield put(modalActions.pushModal(ModalType.STATUS_UPDATE, {
                    wrapInModal: false,
                    params
                }));
                break;
            case DeviationTypes.JOURNAL:
                params.inTiers = expandedDeviationResult.inTiers;
                params.isFeatured = expandedDeviationResult.featured || get(params, 'deviation.extended.isFeaturedJournal', false);
                /** TODO: Uncomment when we know what the actual mature field on journals is
        params.isMature =
          expandedDeviationResult.mature ||
          get(params, 'deviation.extended.isMatureJournal', false);
        */ yield all([
                    put(modalActions.initModal(ModalType.JOURNAL, {
                        params
                    })),
                    put(modalActions.pushModal(ModalType.JOURNAL, {
                        wrapInModal: false,
                        params
                    }))
                ]);
                break;
            case DeviationTypes.LITERATURE:
                yield put(modalActions.pushModal(ModalType.LITERATURE, {
                    wrapInModal: false,
                    params
                }));
                break;
            case DeviationTypes.COMMISSION:
                yield put(modalActions.pushModal(ModalType.COMMISSION, {
                    wrapInModal: false,
                    params
                }));
                break;
            case DeviationTypes.POLL:
                yield put(modalActions.pushModal(ModalType.POLL_EDIT, {
                    wrapInModal: false,
                    params
                }));
                break;
            case DeviationTypes.TIER:
                yield put(modalActions.pushModal(ModalType.TIER_EDIT, {
                    wrapInModal: false,
                    params: expandedDeviationResult
                }));
                break;
            default:
        }
        return;
    }
    if (legacyTextEditUrl) {
        return typeof window !== 'undefined' && window.location.assign(legacyTextEditUrl);
    }
    typeof window !== 'undefined' && window.location.assign(getDeviationUrl(deviation));
}
export function* fetchDeviationSaga({ payload: { deviationid, username, type, onSuccess } }) {
    const result = yield call(doGetPapiRequest, '/deviation/fetch', {
        deviationid,
        username,
        type
    });
    if (result && !isApiError(result)) {
        // Sometimes the deviation id in our payload is a stash private id.
        // This will still get us the papi_deviation, but its deviation_id won't be the private one.
        // Thus we get the id from the api response to lookup from the entities store and avoid a key mismatch.
        const deviationId = result.deviationId;
        const { entities } = normalize(result, deviationSchema);
        yield put(putEntities({
            entities
        }));
        if (onSuccess) {
            const deviation = yield select(getDeviationById, deviationId);
            yield call(onSuccess, deviation);
        }
    }
}
// increment comment count on deviations when new comments are posted
function* handlePublishComment({ payload: { isEdit, comment } }) {
    var _deviation_stats;
    if (isEdit || !comment) {
        return;
    }
    const deviationTypeId = getDeviationTypeForCommentableType(comment.typeId);
    const entityId = getCompositeId(deviationTypeId, comment.itemId);
    // stats are not normalized so we can just work with the normalized deviations
    const deviation = yield select(getNormalizedDeviationById, entityId);
    if (!deviation) {
        return;
    }
    var _deviation_stats_comments;
    const updatedDeviation = _object_spread_props(_object_spread({}, deviation), {
        stats: _object_spread_props(_object_spread({
            favourites: 0
        }, deviation.stats), {
            comments: ((_deviation_stats_comments = (_deviation_stats = deviation.stats) === null || _deviation_stats === void 0 ? void 0 : _deviation_stats.comments) !== null && _deviation_stats_comments !== void 0 ? _deviation_stats_comments : 0) + 1
        }),
        hasCommentedOn: true
    });
    yield put(putEntities({
        entities: {
            [deviationSchema.key]: {
                [entityId]: updatedDeviation
            }
        }
    }));
}
function* handleAwardBadge(action) {
    const { recipient, allBadges } = action.payload;
    if (!(recipient.typeId in DeviationResourceType)) {
        return;
    }
    const deviation = yield select(getDataEntityById, deviationSchema, recipient.itemId);
    const extendedData = yield select(getDataEntityById, deviationExtendedSchema, recipient.itemId);
    if (!deviation || !extendedData) {
        return;
    }
    const updatedDeviation = _object_spread({}, deviation);
    const { entities: deviationNormalized } = normalize(updatedDeviation, deviationSchema);
    yield put(putEntities({
        entities: _object_spread_props(_object_spread({}, deviationNormalized), {
            [deviationExtendedSchema.key]: {
                [recipient.itemId]: _object_spread_props(_object_spread({}, extendedData), {
                    awardedBadges: allBadges
                })
            }
        })
    }));
}
export default function* saga() {
    yield all([
        takeLatest(editDeviation, editDeviationSaga),
        takeLatest(deleteDeviation, deleteDeviationSaga),
        takeLatest(fetchDeviation, fetchDeviationSaga),
        takeEvery(publishCommentSuccess, handlePublishComment),
        takeEvery(publishCommentSuccessNew, handlePublishComment),
        takeEvery(awardBadgeSuccess, handleAwardBadge)
    ]);
}

//# sourceMappingURL=saga.js.map